import React, { useMemo } from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom'

interface IconLinkProps extends RouterLinkProps {}

function IconLink({ children, className, ...props }: IconLinkProps) {
  const classNames = useMemo(() => {
    let result = 'iconButton'
    if (className) result += ` ${className}`
    return result
  }, [className])

  return (
    <RouterLink className={classNames} {...props}>
      {children}
    </RouterLink>
  )
}

export default IconLink
